import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import {
  ActivitiesWorkDay,
  ActivityDayListViewDto,
  ActivityDaysServiceProxy,
  AllocationSheetsServiceProxy,
  IActivityDayViewDto,
  VarianceFromPlanReasonsServiceProxy,
} from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'app-allocation-activity-item',
  templateUrl: './allocation-activity-item.component.html',
  styleUrls: ['./allocation-activity-item.component.less'],
})
export class AllocationActivityItemComponent
  extends AppComponentBase
  implements OnInit, AfterViewInit {
  private _day: ActivitiesWorkDay


  get day() {
    return this._day;
  }
  @Input()
  set day(val) {
    this.activityDays = val.activityDays.map(day => ({ ...day, isOpen: true }))
    this._day = val
  }
  @Input() allocationSheetId;

  @Output() openActivityPanel: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  onRemoveFromAllocation: EventEmitter<any> = new EventEmitter<any>();

  variancesFromPlanReasons;
  activityDays = null

  constructor(
    injector: Injector,
    private _activityDaysServiceProxy: ActivityDaysServiceProxy,
    private _varianceFromPlanServiceProxy: VarianceFromPlanReasonsServiceProxy,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy,
    private cdr: ChangeDetectorRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    abp.event.on('app.evt.activityChanged', () => {
      this.getActivityDayDetails();
    })
    this._varianceFromPlanServiceProxy
      .getAll(null, null, null, null, 0, 999999)
      .subscribe((data) => (this.variancesFromPlanReasons = data.items));
    this.cdr.detectChanges();
  }

  getActivityDayDetails(){
    this.activityDays.forEach(activityDay => {
      this.toggleActivityDayDetailsSection(activityDay.activityDayId, activityDay.isOpen)
      this._activityDaysServiceProxy
        .getMyActivityDayForEdit(activityDay.activityDayId)
        .subscribe((data) => {
          activityDay["detailedActivity"] = data.activityDay
        });
    });
  }
  ngAfterViewInit() {
    this.getActivityDayDetails();
  }

  toggleActivityDayDetailsSection(
    activityDayId: string, isOpen: boolean
  ): void {
    this.activityDays.forEach(element => {
      if (element.activityDayId === activityDayId)
        element.isOpen = isOpen
    });
  }

  isAnyResouceSelected(activityDayId: string){
    let retValue = false
    this.activityDays.forEach(element => {
      if (element.activityDayId === activityDayId)
      {
        retValue =  ( element.detailedActivity.allocatedMaterials.allocatedMaterialsHours>0 
        || element.detailedActivity.allocatedPersonnel.allocatedPersonnelHours>0
        || element.detailedActivity.allocatedPlants.allocatedPlantsHours>0)
      }
    });
    return retValue
  }

  openActivityEditPanel(activityDayId) {
    this.openActivityPanel.emit({ activityDayId });
  }

  removeFromAllocation(allocationSheetId: string, activityDayId: string) {
    this.message.confirm(
      this.l('RemoveFromAllocation'),
      this.l('AreYouSure'),
      (isConfirmed) => {
        if (isConfirmed) {
          this._allocationSheetsServiceProxy
            .removeActivityDayFromAllocationSheet(
              allocationSheetId,
              activityDayId
            )
            .subscribe(() => {
              this.notify.success(
                this.l('TheActivityWasRemovedFromTheAllocationSheet')
              );
              this.onRemoveFromAllocation.emit();
            });
        }
      }
    );
  }

  openEdit(activityDayId: string): void {
    this.toggleActivityDayDetailsSection(activityDayId, true);
    this.openActivityEditPanel(activityDayId);
  }

  checkCompleteToBeSubmitted(activityDay: IActivityDayViewDto): void {
    abp.event.trigger('evt.isCompleteToBeSubmittedRefresh', {
      activityDayId: activityDay.activityDayId,
      activityId: activityDay.activityId,
    });
  }
}
